export default __webpack_public_path__ + "static/media/download-android-app.74132985.svg";